import { html } from "lit-html";
import { WIDGETS } from "Services/constants";

export interface Props {
	culture: string;
}

export const useCarsTab = (props: Props) => {
	const htmlTemplate = () => {
		const carUrl = WIDGETS.get(props.culture.toLowerCase())?.carUrl || WIDGETS.get("default")?.carUrl;

		return html`
			<div>
				<iframe src=${carUrl} height="432" width="100%" scrolling="no" frameborder="0"></iframe>
			</div>
		`;
	};

	return { htmlTemplate };
};
